import axios from "axios";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import * as actions from "../../reducers/notice/index";

function loadListAPI(payload) {
  return axios.get(`/api/cm/notice`, {
    params: { ...payload },
  });
}

function* loadList({ payload }) {
  console.log("payload: ============================== ", payload);

  yield put({
    type: actions.LOADING,
    payload: true,
  });
  try {
    const response = yield call(loadListAPI, payload);
    console.log("response: ", response);
    console.log(
      "response.data.data.noticeList: ",
      response.data.data.noticeList
    );

    yield put({
      type: actions.LOAD_NOTICE_LIST_SUCCESS,
      payload: response.data.data.noticeList,
    });
  } catch (error) {
    console.log("error: ", error);
  }

  yield put({
    type: actions.LOADING,
    payload: false,
  });
}

function* watchLoadList() {
  yield takeEvery(actions.LOAD_NOTICE_LIST, loadList);
}

export default function* noticeSaga() {
  yield all([fork(watchLoadList)]);
}
